import { Box, Group, Text } from "@mantine/core"
import { ReactNode } from "react"
import classes from "./label-field.module.css"

type Variant = "default" | "editorial"

type Props = {
  label: ReactNode
  value?: ReactNode
  /** Optional leading icon rendered inline with the value */
  icon?: ReactNode
  /**
   * "default" — small dimmed label above a medium bold value (used in
   *   detail headers / detail cards where rows sit inside a bordered Paper).
   * "editorial" — uppercase letter-spaced tiny label + tabular-nums value
   *   with a dashed divider underneath (used in the sidebar summary flow).
   */
  variant?: Variant
  /** Override the placeholder shown when value is null/undefined/empty */
  placeholder?: string
}

export function LabelField({ label, value, icon, variant = "default", placeholder = "-" }: Props) {
  const displayValue = value == null || value === "" ? placeholder : value

  return (
    <Box className={classes.root} data-variant={variant}>
      <Text className={classes.label} data-variant={variant}>
        {label}
      </Text>
      {icon ? (
        <Group gap={6} wrap="nowrap" align="center">
          {icon}
          <Text className={classes.value} data-variant={variant}>
            {displayValue}
          </Text>
        </Group>
      ) : (
        <Text className={classes.value} data-variant={variant}>
          {displayValue}
        </Text>
      )}
    </Box>
  )
}
